import React, { ComponentProps, forwardRef } from 'react';

import { IDEALIST_UTM_PARAMS } from 'utils/constants';
import { hasUTMParam, isExternalURL, pathWithParams } from 'utils/url';

import { SecondaryButtonDanger } from './SecondaryButtonDanger';

export const SecondaryButtonDangerLink = forwardRef<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  ComponentProps<typeof SecondaryButtonDanger>
>( // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ({ href, ...props }, ref) => (
    <SecondaryButtonDanger
      href={
        isExternalURL(href) && !hasUTMParam(href)
          ? pathWithParams(href, IDEALIST_UTM_PARAMS)
          : href
      }
      component="a"
      type={undefined}
      ref={ref}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
);
